// Utils
import { convertNumber } from "utils"

export function SummaryBox(params: {
  amount: number
  label: string
}) {
  return (
    <div className="min-w-[100px] h-20 border flex flex-col justify-center text-center">
      <div>Summary</div>
      <div>{params.label}</div>
      <div className="mt-2 font-bold">{convertNumber(params.amount).intoCurrency}</div>
    </div>
  )
}